export default __webpack_public_path__ + "static/media/step4.57483506.svg";